import moment from "moment";
export const generateDropDownData = (fyData) => {
    let data = [];
    if (fyData.length > 0) {
        fyData?.forEach((item) => {
            data.push({
                label: item.label,
                value: JSON.stringify(item.value)
            });
        });
    }
    return data;
};
export const getCurrentDate = () => {
    // Get the current date
    const currentDate = moment();
    // Format the date as dd-mm-yyyy
    const formattedDate = currentDate.format('DD-MM-YYYY');
    return formattedDate;
};
export const formatDateToText = (inputDate) => {
    // Parse the input date
    const parsedDate = moment(inputDate, 'DD-MM-YYYY');
    // Format the date as 2 March, 2024
    const formattedDate = parsedDate.format('D MMMM, YYYY');
    return formattedDate;
};
export const dateFormatForBE = (inputDate) => {
    // Parse the input date
    const parsedDate = moment(inputDate, 'DD-MM-YYYY');
    // Format the date as 12-MAR-2024
    const formattedDate = parsedDate.format('DD-MMM-YYYY').toUpperCase();
    return formattedDate;
};
export const dateFormatDropDown = (dateString, ignore) => {
    // Input date string
    // Parse the input date string using moment
    const date = moment(dateString, 'DD-MMM-YYYY');
    // Format the date in the desired format
    const formattedDate = date.format('DD-MM-YYYY');
    console.log("formattedDate: ", formattedDate); // Output: 31-03-2023
    if (ignore && formattedDate.includes('2024')) {
        return "";
    }
    return formattedDate;
};
